module.exports = __webpack_public_path__ + "media/honey-icons/icon-flow-low-dd95c2d5.svg";